import { useAuthenticatedRequest } from '@komune-io/g2-providers'

export const usePlatformRequest = () => {
  const requestProps = useAuthenticatedRequest()
  // @ts-ignore
  const platformUrl = window._env_?.config?.platform?.baseUrl
  return { ...requestProps, url: platformUrl }
}
